import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const pdsTableBodyCss = ":host{border-color:inherit;display:table-row-group;vertical-align:middle}";

const PdsTableBody$1 = /*@__PURE__*/ proxyCustomElement(class PdsTableBody extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    render() {
        return (h(Host, { key: 'ac8d361f2d78eb929c17523843d2ca0ac53f6789', role: "rowgroup" }, h("slot", { key: '132782ab9466a9dbd4350247aae762d731e7aa71' })));
    }
    static get style() { return pdsTableBodyCss; }
}, [1, "pds-table-body"]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["pds-table-body"];
    components.forEach(tagName => { switch (tagName) {
        case "pds-table-body":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, PdsTableBody$1);
            }
            break;
    } });
}

const PdsTableBody = PdsTableBody$1;
const defineCustomElement = defineCustomElement$1;

export { PdsTableBody, defineCustomElement };
//# sourceMappingURL=pds-table-body.js.map

//# sourceMappingURL=pds-table-body.js.map